export const TypeLarge = () => (
    <div>
        <h5>Los alumnos responderán la pregunta de forma libre y explayada</h5>
    </div>
)
